import React, { useMemo } from "react"
import cn from "../../../utils/classes"
import Typography, { typographyTypes } from "./Typography"

interface DropDownButtonItemProps {
  label: string
  onClick?: () => void
  rootStyleOverrides?: string
  typographyStyleOverrides?: string
}

// TODO: Add accessibility.
export const DropDownButtonItem: React.FC<DropDownButtonItemProps> = ({
  label,
  onClick,
  rootStyleOverrides,
  typographyStyleOverrides,
}) => {
  const rootClassName = useMemo(() => {
    // Note: HA Design system style
    const defaultStyles = [
      "group",
      "hover:bg-dark-purple",
      "hover:text-white",
      "px-4",
      "py-2",
      "rounded-md",
      "cursor-pointer",
      "focus:outline-none",
      "focus:bg-dark-purple",
    ]
    return cn(defaultStyles, rootStyleOverrides)
  }, [rootStyleOverrides])

  const typographyClassName = useMemo(() => {
    // Note: HA Design system style
    const defaultStyles = [
      "group-hover:text-white",
      "group-focus:text-white",
      "hover:text-white",
      "whitespace-nowrap",
      "cursor-pointer",
      "font-[400]",
      "text-[14px]",
      "leading-[21px]",
    ]
    return cn(defaultStyles, typographyStyleOverrides)
  }, [typographyStyleOverrides])

  return (
    <div
      className={rootClassName}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          if (event.key === " ") {
            event.preventDefault()
          }
          if (onClick) {
            onClick()
          }
        }
      }}
      role="button"
      tabIndex={0}
    >
      <Typography
        variant={typographyTypes.NORMAL}
        styleOverrides={typographyClassName}
        text={label}
      />
    </div>
  )
}
